import callAPI from "../callApi";
import path from "../variables";

const Yield = {
	getDynamicPrice: (filter?: string) =>
		callAPI("GET", `${path.base}/business/yield/dynamic-price${filter || ""}`, "", "getting dynamic price"),
	getRoutePricing: (filter?: string) =>
		callAPI("GET", `${path.base}/business/yield/route-pricing${filter || ""}`, "", "getting route pricing"),
};

export default Yield;
